import * as React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Divider from "@mui/material/Divider";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { useEffect } from "react";
import { isCanceledResponse } from "../../bl_libs/invokeApi";
import { unread_conversations_list_api } from "../../DAL/Chatting/Chatting";
import { useState } from "react";
import { useSnackbar } from "notistack";
import Conversations from "../Chatting/Conversations";
import { useNavigate } from "react-router-dom";
import AppLoader from "../GeneralComponents/AppLoader";
import {
  HEADER_MENU_ANCHOR_ORIGIN,
  HEADER_MENU_PAPER_SX,
  HEADER_MENU_TRANSFORM_ORIGIN,
} from "../../utils/headerMenuStyles";
import { useTranslation } from "react-i18next";

export default function ChatPopover() {
  const { t } = useTranslation();
  const { unreadMessageCount, userInfo, setUnreadMessageCount } =
    useContentSetting();
  const [anchorEl, setAnchorEl] = useState(null);
  const [conversationsList, setConversationsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (userInfo.user_type === "student") {
      setUnreadMessageCount(0);
      navigate("/class-room");
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const get_conversations_list = async (signal = null) => {
    const result = await unread_conversations_list_api(signal);
    if (isCanceledResponse(result)) return;
    if (result.code === 200) {
      setConversationsList(result.conversations_list);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsLoading(false);
  };

  const handleSelected = (row) => {
    navigate(`/class-room/${row._id}`);
    handleClose();
  };
  useEffect(() => {
    if (!open) return;
    const ac = new AbortController();
    get_conversations_list(ac.signal);
    return () => ac.abort();
  }, [open]);

  const conversationsData = {
    conversationsList,
    handleSelected: handleSelected,
    selectedConversation: null,
    is_popup: true,
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <div className="header-button-action" onClick={handleClick}>
          <span>{unreadMessageCount}</span>
          <i className="fa-solid fa-comment-dots"></i>
        </div>
      </Box>
      <Menu
        anchorEl={anchorEl}
        className="chat_popover_menu"
        id="account-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            ...HEADER_MENU_PAPER_SX,
          },
        }}
        transformOrigin={HEADER_MENU_TRANSFORM_ORIGIN}
        anchorOrigin={HEADER_MENU_ANCHOR_ORIGIN}
      >
        <div className="chat-card-section">
          {isLoading ? (
            <div className="circular-progress-popover"><AppLoader size="medium" /></div>
          ) : (
            <>
              <div className="p-3 pt-1 chat-card-heading">
                <h6>{t("chatting.popover.messagesTitle")}</h6>
                <span>{t("chatting.popover.unreadCount", { count: unreadMessageCount })}</span>
              </div>
              <Divider />
              <Conversations {...conversationsData} />
            </>
          )}
        </div>
      </Menu>
    </>
  );
}
